import React, { Component } from "react";
import axios from "axios";
import * as PropTypes from "prop-types";
import { Button, DatePicker, Form, Modal, Radio, Select, Spin, Tag } from "antd";

import moment from "moment";

import { API_ERRO_TYPE_CANCEL } from "./../../config/general";

import { tenantService, tenantUserFunctionService, tenantUserTypeService } from "./../../redux/services";

class Filters extends Component {
	static propTypes = {
		visible   : PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose   : PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.filtersClean = {
			tenant_id  : null,
			type_id    : null,
			function_id: null,
			is_active  : null,
			created_at : null,
		};

		this.state = {
			filters           : {
				...this.filtersClean,
			},
			tenantsIsLoading  : false,
			tenants           : [],
			typesIsLoading    : false,
			types             : [],
			functionsIsLoading: false,
			functions         : [],
		};

		this._axiosCancelTenantsToken   = null;
		this._axiosCancelTypesToken     = null;
		this._axiosCancelFunctionsToken = null;
	}

	fetchTenants = (value) => {
		if( this._axiosCancelTenantsToken )
		{
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		if( !value.trim().length )
		{
			this.setState({
				tenantsIsLoading: false,
				tenants         : [],
			});

			return false;
		}

		this.setState({
			tenantsIsLoading: true,
		});

		tenantService.getAutocomplete({
			search     : value,
			orderBy    : "name:asc",
			cancelToken: this._axiosCancelTenantsToken.token,
		})
		.then((response) => {
			this.setState({
				tenantsIsLoading: false,
				tenants         : response.data.data,
			});
		})
		.catch((data) => {
			if( data.error_type === API_ERRO_TYPE_CANCEL ) return null;

			this.setState({
				tenantsIsLoading: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	fetchTypes = () => {
		this._axiosCancelTypesToken = axios.CancelToken.source();

		this.setState({
			typesIsLoading: true,
		});

		tenantUserTypeService.getAutocomplete({
			orderBy    : "name:asc",
			cancelToken: this._axiosCancelTypesToken.token,
		})
		.then((response) => {
			this.setState({
				typesIsLoading: false,
				types         : response.data.data,
			});
		})
		.catch((data) => {
			if( data.error_type === API_ERRO_TYPE_CANCEL ) return null;

			this.setState({
				typesIsLoading: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	fetchFunctions = () => {
		this._axiosCancelFunctionsToken = axios.CancelToken.source();

		this.setState({
			functionsIsLoading: true,
		});

		tenantUserFunctionService.getAutocomplete({
			orderBy    : "name:asc",
			cancelToken: this._axiosCancelFunctionsToken.token,
		})
		.then((response) => {
			this.setState({
				functionsIsLoading: false,
				functions         : response.data.data,
			});
		})
		.catch((data) => {
			if( data.error_type === API_ERRO_TYPE_CANCEL ) return null;

			this.setState({
				functionsIsLoading: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	onOpen = (filters) => {
		this.setState({
			filters: filters,
		});

		if( !this.state.types.length )
		{
			this.fetchTypes();
		}

		if( !this.state.functions.length )
		{
			this.fetchFunctions();
		}
	};

	cleanFilters = () => {
		this.setState({
			filters: this.filtersClean,
		}, () => {
			// Callback
			this.props.onComplete({...this.state.filters});
		});
	};

	onClose = () => {
		// Callback
		this.props.onClose();
	};

	filtersOnConfirm = () => {
		// Callback
		this.props.onComplete({...this.state.filters});
	};

	setFilter = (name, value) => {
		this.setState(state => ({
			filters: {
				...state.filters,
				[name]: value,
			}
		}));
	};

	render() {
		const {visible} = this.props;

		const {filters, tenantsIsLoading, tenants, typesIsLoading, types, functionsIsLoading, functions} = this.state;

		return (
			<Modal
				visible={visible}
				title="Filtrar"
				centered={true}
				destroyOnClose={true}
				maskClosable={true}
				width={900}
				okText="Aplicar"
				onCancel={this.onClose}
				onOk={this.filtersOnConfirm}
				className="modal-filters"
				footer={[
					<Button key="back" type="link" onClick={this.cleanFilters}>Excluir filtros</Button>,
					<Button key="submit" type="primary" onClick={this.filtersOnConfirm}>Aplicar</Button>,
				]}>
				<div className="filter-group">
					<div className="filter-group-title">
						<h3>Empresa</h3>
					</div>
					<div className="filter-group-filters" style={{paddingBottom: 0}}>
						<Form.Item>
							<Select
								filterOption={false}
								allowClear
								placeholder="Pesquise a empresa"
								notFoundContent={tenantsIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
								onSearch={this.fetchTenants}
								onChange={(value) => this.setFilter("tenant_id", value ?? null)}
								showSearch
								value={this.state.filters.tenant_id}>
								{tenants.map((item, index) => (
									<Select.Option key={index} value={item.uuid}>
										{item.is_active ? item.name : (
											<Tag style={{margin: 0}} color="#777" title="Inativo">{item.name}</Tag>
										)}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</div>
				</div>
				<div className="filter-group">
					<div className="filter-group-title">
						<h3>Tipo</h3>
					</div>
					<div className="filter-group-filters" style={{paddingBottom: 0}}>
						<Form.Item>
							<Select
								optionFilterProp="children"
								filterOption={(input, option) => (typeof option.children === 'string' ? option.children : option.children.props.children).toLowerCase().indexOf(input.toLowerCase()) >= 0}
								allowClear
								placeholder="Selecione o tipo"
								notFoundContent={typesIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
								onChange={(value) => this.setFilter("type_id", value ?? null)}
								showSearch
								value={this.state.filters.type_id}>
								{types.map((item, index) => (
									<Select.Option key={index} value={item.uuid}>
										{item.is_active ? item.name : (
											<Tag style={{margin: 0}} color="#777" title="Inativo">{item.name}</Tag>
										)}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</div>
				</div>
				<div className="filter-group">
					<div className="filter-group-title">
						<h3>Função</h3>
					</div>
					<div className="filter-group-filters" style={{paddingBottom: 0}}>
						<Form.Item>
							<Select
								optionFilterProp="children"
								filterOption={(input, option) => (typeof option.children === 'string' ? option.children : option.children.props.children).toLowerCase().indexOf(input.toLowerCase()) >= 0}
								allowClear
								placeholder="Selecione o tipo"
								notFoundContent={functionsIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
								onChange={(value) => this.setFilter("function_id", value ?? null)}
								showSearch
								value={this.state.filters.function_id}>
								{functions.map((item, index) => (
									<Select.Option key={index} value={item.uuid}>
										{item.is_active ? item.name : (
											<Tag style={{margin: 0}} color="#777" title="Inativo">{item.name}</Tag>
										)}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</div>
				</div>
				<div className="filter-group">
					<div className="filter-group-title" style={{paddingTop: 0}}>
						<h3>Situação</h3>
					</div>
					<div className="filter-group-filters" style={{paddingBottom: 5}}>
						<div className="filter-group-radios">
							<div className="filter-group-radio">
								<Radio onChange={(e) => this.setFilter("is_active", null)} checked={filters.is_active === null}>Todos</Radio>
							</div>
							<div className="filter-group-radio">
								<Radio onChange={(e) => this.setFilter("is_active", 1)} checked={filters.is_active === 1}>Ativo</Radio>
							</div>
							<div className="filter-group-radio">
								<Radio onChange={(e) => this.setFilter("is_active", 0)} checked={filters.is_active === 0}>Inativo</Radio>
							</div>
						</div>
					</div>
				</div>
				<div className="filter-group">
					<div className="filter-group-title">
						<h3>Criação</h3>
					</div>
					<div className="filter-group-filters" style={{paddingBottom: 0}}>
						<Form.Item>
							<DatePicker.RangePicker
								format="DD/MM/YYYY"
								value={filters.created_at}
								onChange={(date, dateString) => this.setFilter("created_at", date ?? null)}
								disabledDate={(currentDate) => currentDate.isAfter(moment(), "day")}
							/>
						</Form.Item>
					</div>
				</div>
			</Modal>
		)
	}
}

export default Filters;
